module.exports = __webpack_public_path__ + "static/media/icon-participant-info-off.bc6b8a50.svg";